module.exports = __webpack_public_path__ + "static/media/ONE.d6299616.png";